const readWeightDetails = (item) =>
  item?.weightDetails ?? item?.weight_details ?? null;

const readLogisticsDetails = (item) =>
  item?.logisticsDetails ?? item?.logistics_details ?? null;

export const formatProductPackSize = (item) => {
  const weight = readWeightDetails(item);
  const logistics = readLogisticsDetails(item);
  const packageQty =
    logistics?.packageQuantity ?? logistics?.package_quantity ?? null;
  const netContent = weight?.netContent ?? weight?.net_content ?? null;
  const unit = weight?.unitOfMeasure ?? weight?.unit_of_measure ?? null;

  if (!netContent && !(Number(packageQty) > 1)) return "-";

  const parts = [];
  if (Number(packageQty) > 1) {
    parts.push(`${packageQty} ×`);
  }
  const volume = [netContent, unit].filter(Boolean).join(" ");
  if (volume) parts.push(volume);

  return parts.length ? parts.join(" ") : "-";
};

export const getProductPackSizeSortValue = (item) => {
  const label = formatProductPackSize(item);
  return label === "-" ? "" : label;
};

export const getProductHeaderMetaParts = (
  product,
  { includeGtin = false } = {},
) => {
  if (!product) return [];

  const name =
    product.name || product.productName || product.ProductName || null;
  const packSize = formatProductPackSize(product);

  return [
    name,
    product.subBrand?.name,
    packSize !== "-" ? packSize : null,
    includeGtin ? product.gtin : null,
  ].filter(Boolean);
};
